window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


'use strict';
window.Berserk.section = window.Berserk.section || {};


/*================ Berserk ================*/
Berserk.revolutionSlider = {
    section: {
        init: function() {
            var revapi34, revapi16, tpj;
            var $slider = $('.rev_slider');

            if (tpj === undefined) {
                tpj = jQuery;
                if ("off" == "on") tpj.noConflict();
            }
            if ($('#rev_slider_34_1').length >0 ) {
                revapi34 = tpj("#rev_slider_34_1").show().revolution({
                    sliderType: "standard",
                    sliderLayout: "fullscreen",
                    dottedOverlay: "none",
                    autoplay: false,
                    delay: 6000,
                    navigation: {
                        keyboardNavigation: "off",
                        keyboard_direction: "horizontal",
                        mouseScrollNavigation: "off",
                        mouseScrollReverse: "default",
                        onHoverStop: "off",
                        thumbnails: {
                            style: "hesperiden",
                            enable: true,
                            width: 95,
                            height: 95,
                            min_width: 95,
                            wrapper_padding: 10,
                            wrapper_color: "rgb(255,255,255)",
                            tmp: '<span class="tp-thumb-image"></span><span class="tp-thumb-title">{{title}}</span>',
                            visibleAmount: 4,
                            hide_onmobile: true,
                            hide_under: 992,
                            hide_onleave: false,
                            direction: "horizontal",
                            span: false,
                            position: "inner",
                            space: 10,
                            h_align: "right",
                            v_align: "bottom",
                            h_offset: 390,
                            v_offset: 0
                        }
                    },
                    responsiveLevels: [1240, 1024, 778, 480],
                    visibilityLevels: [1240, 1024, 778, 480],
                    gridwidth: [1200, 992, 768, 576],
                    gridheight: [900, 768, 960, 720],
                    lazyType: "none",
                    parallax: {
                        type: "mouse",
                        origo: "enterpoint",
                        speed: 400,
                        speedbg: 0,
                        speedls: 0,
                        levels: [4, 6, 8, 10, 12, 30, 35, 40, 45, 46, 47, 48, 49, 50, 51, 55],
                        disable_onmobile: "on"
                    },
                    shadow: 0,
                    spinner: "spinner2",
                    stopLoop: "on",
                    stopAfterLoops: 1,
                    stopAtSlide: 1,
                    shuffle: "off",
                    autoHeight: "off",
                    fullScreenAutoWidth: "on",
                    fullScreenAlignForce: "off",
                    fullScreenOffsetContainer: "",
                    fullScreenOffset: "",
                    disableProgressBar: "on",
                    hideThumbsOnMobile: "on",
                    hideSliderAtLimit: 0,
                    hideCaptionAtLimit: 0,
                    hideAllCaptionAtLilmit: 0,
                    debugMode: false,
                    fallbacks: {
                        simplifyAll: "on",
                        nextSlideOnWindowFocus: "off",
                        disableFocusListener: false,
                    }
                });
            } 
            if ($('#rev_slider_16_1').length >0) {
                revapi16 = tpj("#rev_slider_16_1").show().revolution({
                    sliderType: "standard",
                    jsFileLocation: "vendor/revslider/js/",
                    sliderLayout: "fullscreen",
                    dottedOverlay: "none",
                    delay: 6000,
                    navigation: {
                        keyboardNavigation: "off",
                        keyboard_direction: "horizontal",
                        mouseScrollNavigation: "off",
                        mouseScrollReverse: "default",
                        onHoverStop: "off",
                        bullets: {
                            enable: true,
                            hide_onmobile: false,
                            hide_over: 991,
                            style: "zeus",
                            hide_onleave: true,
                            hide_delay: 200,
                            hide_delay_mobile: 1200,
                            direction: "horizontal",
                            h_align: "center",
                            v_align: "bottom",
                            h_offset: 0,
                            v_offset: 20,
                            space: 5,
                            tmp: '<span class="tp-bullet-image"></span><span class="tp-bullet-imageoverlay"></span><span class="tp-bullet-title">{{title}}</span>'
                        },
                        thumbnails: {
                            style: "hesperiden",
                            enable: true,
                            width: 95,
                            height: 95,
                            min_width: 95,
                            wrapper_padding: 15,
                            wrapper_color: "rgb(255,255,255)",
                            tmp: '<span class="tp-thumb-image"></span><span class="tp-thumb-title">{{title}}</span>',
                            visibleAmount: 6,
                            hide_onmobile: true,
                            hide_under: 992,
                            hide_onleave: false,
                            direction: "vertical",
                            span: false,
                            position: "inner",
                            space: 10,
                            h_align: "left",
                            v_align: "center",
                            h_offset: 0,
                            v_offset: 0
                        }
                    },
                    responsiveLevels: [1240, 1024, 778, 480],
                    visibilityLevels: [1240, 1024, 778, 480],
                    gridwidth: [1200, 992, 768, 576],
                    gridheight: [960, 768, 960, 720],
                    lazyType: "none",
                    minHeight: "800",
                    parallax: {
                        type: "mouse",
                        origo: "slidercenter",
                        speed: 400,
                        speedbg: 0,
                        speedls: 0,
                        levels: [4, 6, 8, 10, 12, 30, 35, 40, 45, 46, 47, 48, 49, 50, 51, 55],
                        disable_onmobile: "on"
                    },
                    shadow: 0,
                    spinner: "spinner2",
                    stopLoop: "off",
                    stopAfterLoops: -1,
                    stopAtSlide: -1,
                    shuffle: "off",
                    autoHeight: "off",
                    fullScreenAutoWidth: "on",
                    fullScreenAlignForce: "off",
                    fullScreenOffsetContainer: "",
                    fullScreenOffset: "",
                    disableProgressBar: "on",
                    hideThumbsOnMobile: "on",
                    hideSliderAtLimit: 0,
                    hideCaptionAtLimit: 0,
                    hideAllCaptionAtLilmit: 0,
                    debugMode: false,
                    fallbacks: {
                        simplifyAll: "off",
                        nextSlideOnWindowFocus: "off",
                        disableFocusListener: false,
                    }
                });
            } 
            if ($('#rev_slider_4_1').length >0) {
                revapi4 = tpj("#rev_slider_4_1").show().revolution({
                    sliderType: "standard",
                    jsFileLocation: "vendor/revslider/js/",
                    sliderLayout: "fullwidth",
                    dottedOverlay: "none",
                    delay: 5000,
                    navigation: {
                        keyboardNavigation: "off",
                        keyboard_direction: "horizontal",
                        mouseScrollNavigation: "off",
                        mouseScrollReverse: "default",
                        onHoverStop: "off",
                        arrows: {
                            style: "hephaistos",
                            enable: true,
                            hide_onmobile: true,
                            hide_under: 768,
                            hide_onleave: true,
                            hide_delay: 200,
                            hide_delay_mobile: 1200,
                            tmp: '',
                            left: {
                                h_align: "left",
                                v_align: "center",
                                h_offset: 10,
                                v_offset: 0
                            },
                            right: {
                                h_align: "right",
                                v_align: "center",
                                h_offset: 10,
                                v_offset: 0
                            }
                        },
                        bullets: {
                            enable: true,
                            hide_onmobile: false,
                            hide_over: 768,
                            style: "hermes",
                            hide_onleave: false,
                            direction: "horizontal",
                            h_align: "center",
                            v_align: "bottom",
                            h_offset: 0,
                            v_offset: 20,
                            space: 5,
                            tmp: ''
                        }
                    },
                    responsiveLevels: [1240, 1024, 778, 480],
                    visibilityLevels: [1240, 1024, 778, 480],
                    gridwidth: [1230, 992, 768, 576],
                    gridheight: [850, 800, 960, 800],
                    lazyType: "none",
                    minHeight: "800",
                    parallax: {
                        type: "mouse",
                        origo: "enterpoint",
                        speed: 400,
                        speedbg: 0,
                        speedls: 0,
                        levels: [4, 6, 8, 10, 12, 30, 35, 40, 45, 46, 47, 48, 49, 50, 51, 55],
                        disable_onmobile: "on"
                    },
                    shadow: 0,
                    spinner: "spinner2",
                    stopLoop: "off",
                    stopAfterLoops: -1,
                    stopAtSlide: -1,
                    shuffle: "off",
                    autoHeight: "off",
                    disableProgressBar: "on",
                    hideThumbsOnMobile: "on",
                    hideSliderAtLimit: 0,
                    hideCaptionAtLimit: 0,
                    hideAllCaptionAtLilmit: 0,
                    debugMode: false,
                    fallbacks: {
                        simplifyAll: "off",
                        nextSlideOnWindowFocus: "off",
                        disableFocusListener: false,
                    }
                });
            }
        },
        destroy: function() {
            // Berserk.revolutionSlider.revapi.revkill();
        }
    }
};

Berserk.myCart = {
    construct: function() {
        this.settings = {
            max_products: 3
        };

        this.dom = {
            $count: $('#CartCount'),
            $list: $('.brk-mini-cart__products'),
            $currency: $('#currencies'),
            $pd_expl: $('.product__example'),
            $empty: $('.tt-header__cart-empty'),
            $more: $('.tt-header__cart-more')
        };

        this.attr = {
            popup_enable: 'data-active'
        };

        this.dom.$pd_expl = this.dom.$pd_expl.detach().removeClass('tt-header__cart-example');

        $(document).on('click', '.mfp-content [data-action="close"]', function() {
            $(this).parents('.mfp-content').find('.mfp-close').trigger('click');
        });
    },
    init: function() {
        Berserk.myCart = new this.construct;
        // Berserk.myCart.update();
    }
};

Berserk.myCart.construct.prototype = $.extend({}, Berserk.myCart.construct.prototype, {
    addItem: function(obj) {
        var _self = this;

        $.getJSON({
            url: '/cart/add.js',
            type: 'POST',
            data: obj.data,
            success: function(data) {
                var popup_enable = _self.dom.$popup_tocart.attr(_self.attr.popup_enable);

                if(data.id > 0) {
                    if(popup_enable === 'true' && obj.$btn) {
                        _self.showPopup(obj.$btn);
                    }

                    _self.update();
                }

                if(obj.callback && typeof obj.callback === 'function') {
                    obj.callback(data);
                }
            },
            error: function(e) {
                if(e.responseJSON.status === 422) {
                    alert(e.responseJSON.description)
                }

                if(obj.callback && typeof obj.callback === 'function') {
                    obj.callback({}, 'abort');
                }
            }
        });
    },

    update: function() {
        var _self = this,
            $list = this.dom.$list;

        if($list.length) {
            $list.addClass('ttg-loading');

            $.getJSON("/cart.js", function (data, cart) {
                _self.updatePopup(data);
                _self.updateCount(data.item_count);

                $list.removeClass('ttg-loading');
            })
        }
    }, 

    updatePopup: function (cart) {
        var $mini_cart = this.dom.$mini_cart,
            $list = this.dom.$list,
            $pd_expl = this.dom.$pd_expl,
            $empty = this.dom.$empty,
            $more = this.dom.$more,
            money_format = theme.moneyFormat,
            max_products = this.settings.max_products;

        $(".brk-mini-cart__products >div").remove();

        if(cart.item_count > 0) {
            if(cart.items.length > max_products) {
                $more.removeClass('ttg-hidden');
            } else {
                $more.addClass('ttg-hidden');
            }

            // <p class="empty_cart">Cart is empty</p>
            $('p.empty_cart').remove();
            
            var $pds_wrap = $('.brk-mini-cart__products');

            $.each(cart.items, function(i) {

                var $pd = $pd_expl.clone(),
                    $pd_image = $pd.find('.brk-mini-cart__product--img img'),
                    $pd_info = $pd.find('.brk-mini-cart__product--title-price'),
                    $pd_title = $pd_info.find('a h4'),
                    $pd_price = $pd.find('.brk-mini-cart__product--price'),
                    $pd_old_price = $pd.find('.brk-mini-cart__product--old-price'),
                    $pd_links = $pd_info.find('a'),
                    $pd_count = $pd.find('.brk-quantity__value');

                if (parseInt(Shopify.formatMoney(this.compare_at_price, money_format).replace(/\D+/g,""), 10) !== 0) {
                }

                $pd.attr('data-prdbut-id', this.variant_id).attr('data-prdbut-selected', true);
                $pd_title.text(this.product_title);
                $pd_links.attr('href', this.url);
                $pd_image.attr('src', slate.Image.getSizedImageUrl (this.image, '104x'));
                $pd_image.attr('alt', this.product_title);
                $pd_price.append('<span class="money">' + Shopify.formatMoney(this.price, money_format) + '</span>');
                $pd_count.val(this.quantity);

                if (this.variant_options.length > 0 && this.variant_title != null ) {
                   $pd_old_price.html(this.variant_title);
                }

                $pds_wrap.append($pd);
            });
        } else {
            $more.addClass('ttg-hidden');
            $empty.removeClass('ttg-hidden');
            $('.brk-mini-cart__products').append('<p class="empty_cart">Cart is empty</p>')
        }
        Berserk.currency.update();
    },

    removeItem: function(id, callback) {
         this.changeItem(id, 0, callback);
    },

    changeItem: function(id, quantity, callback) {
        var _self = this;

        $.getJSON({
            url: '/cart/change.js',
            type: 'POST',
            data: 'quantity=' + quantity + '&id=' + id,
            success: function(data) {
                _self.update();

                if(callback && typeof callback === 'function') {
                    callback(data);
                }
            }
        });
    },

    updateCount: function(count) {
        var $count = this.dom.$count;

        $count.text(count);

        if(count > 0) {
            $count.removeClass('ttg-hidden');
        } else {
            $count.addClass('ttg-hidden');
        }
    }

    // loadPage: function(cart)
});
Berserk.productController = {
    construct: function () {
        this.settings = {
            variant_info_default_id: 'default_variant_id',
            variants_info_replace: '_replace',
            variants_info_visible: '_visible',
            variants: 'variants',
            visible_disabled_class: 'disabled',
            variants_info: '_',
        };

        this.dom = {
            $prdbut: $('body'),
            $body: $('body')
        };

        this.selector = {
            product: '.prdbut__product',
            cart_count: '.brk-quantity__value',
            cart_del: '.brk-mini-cart__product--remove',
            cart_product: '.brk-mini-cart__product',
            option: '.prdbut__option',
            option_select: '.prdbut__option--select',
        };

        this.attr = {
            variant_selected: 'data-prdbut-selected',
            variant_id: 'data-prdbut-id',
            variant_current: 'data-prdbut-current',
            obj: 'data-prdbut-variants',
            option_group: 'data-prdbut-group',
            option_value: 'data-prdbut-value',
            check_cart: 'data-prdbut-cart-id',
            replace_elem: 'data-prdbut-replace',
        };

        this._variantsHandlers();
        this._tocartHandlers();
    },
    init: function() {
        this.build = new this.construct;
    },
    destroy: function() {
        this.dom.$prdbut.off();

        this.build = null;
    }
};

Berserk.productController.construct.prototype = $.extend({}, Berserk.productController.construct.prototype, {
    _variantsHandlers: function() {
        var _self = this,
            _product = this.selector.product,
            _obj = this.attr.obj,
            _current = this.attr.variant_current,
            _option = this.selector.option,
            _group = this.attr.option_group,
            _value = this.attr.option_value,
            _default = this.settings.variant_info_default_id,
            _variants = this.settings.variants,
            _info = this.settings.variants_info;

        function activeVariant(current_obj, fit_arr) {
            var active_obj = null;

            $.each(fit_arr, function() {
                var variant = _self._methods._cloneObj(this);

                delete variant[_info];

                if(_self._methods._isEqual(current_obj, variant)) {
                    active_obj = this;

                    return false;
                };
            });

            return active_obj;
        };

        function fitVariants(current_obj, variants_arr) {
            var fit_arr = [],
                variants_arr = variants_arr.slice();

            $.each(current_obj, function(k, v) {
                for(var i = 0; i < variants_arr.length; i++) {
                    if(variants_arr[i][k] === v) {
                        fit_arr.push(variants_arr[i]);
                        variants_arr.splice(i, 1);
                        i--;
                    }
                }
            });

            return fit_arr;
        };

        this.dom.$prdbut.on('click', _option + ' a[' + _value + ']', function (e) {
            e.preventDefault();

            var $btn = $(this);

            if($btn.hasClass('default')) return;

            var $pd = $btn.parents(_product),
                $option = $btn.parents(_option),
                is_act = $btn.hasClass('active'),
                obj = _self._methods._parseJSON($pd.attr(_obj)),
                variants_arr = obj[_variants] ? obj[_variants] : [],
                active_obj = {};

            var value = $btn.attr(_value),
                group = $option.attr(_group),
                current_obj = _self._methods._parseJSON($pd.attr(_current)),
                click_obj = {},
                click_fit_arr = [];

            current_obj[group] = value;
            click_obj[group] = value;

            active_obj = activeVariant(current_obj, variants_arr);
            click_fit_arr = fitVariants(click_obj, variants_arr);

            if(!active_obj) active_obj = click_fit_arr[0];

            _self.setVariant($pd, {
                active_obj: active_obj,
                click_fit_arr: click_fit_arr
            });
        });

    },
    setVariant: function($pd, data, obj_update) {
        if(!data.active_obj) return;

        var _self = this,
            _option = this.selector.option,
            _options_select = this.selector.option_select,
            _selected = this.attr.variant_selected,
            _current = this.attr.variant_current,
            _value = this.attr.option_value,
            _info = this.settings.variants_info,
            $options_all = $pd.find(_option),
            $options_not_select = $options_all.not(_options_select),
            $options_select = $options_all.filter(_options_select),
            $options_all_span = $options_all.find('a[' + _value + ']'),
            $options_all_option = $options_select.find('option[' + _value + ']'),
            active_obj = data.active_obj,
            current_obj = this._methods._cloneObj(active_obj, _info),
            click_fit_arr = data.click_fit_arr || [];

        

        $options_all_span.removeClass('default');
        if(active_obj['default'] && active_obj['default'] === true) {
            obj_update = $.extend({}, { url: 'remove' }, obj_update);
            this._toggleState($options_not_select, 'a', active_obj, 'addClass', 'default');
        }

        $pd.attr(_selected, true);

        if(!click_fit_arr.length) click_fit_arr.push(active_obj);

        $options_all_span.addClass('disabled');
        $.each(click_fit_arr, function() {
            _self._toggleState($options_not_select, 'a', this, 'removeClass', 'disabled');
        });

        $options_all_span.removeClass('active');
        this._toggleState($options_not_select, 'a', active_obj, 'addClass', 'active');

        $options_all_option.removeAttr('selected');
        this._toggleState($options_select, 'option', active_obj, 'prop', 'selected', true);

        if(active_obj[_info]) this.replacePdInfo($pd, active_obj[_info], obj_update);

        this._methods._setAttrObjJSON($pd, _current, current_obj);
    },
    _toggleState: function($options_all, elem, obj, act, state, state_value) {
        var  _group = this.attr.option_group,
            _value = this.attr.option_value,
            _info = this.settings.variants_info;

        $.each(obj, function(k, v) {
            if(k === _info) return;

            $options_all.filter('[' + _group + '="' + k + '"]').find(elem + '[' + _value + '="' + v + '"]')[act](state, state_value);
        });
    },
    replacePdInfo: function($pd, obj, obj_update) {
        var _id = this.attr.variant_id,
            _check_cart = this.attr.check_cart,
            _cart_add = this.selector.cart_add,
            _cart_toggle = this.selector.cart_toggle,
            _image_toggle = obj['image_id'],
            _btns_cart_add = _cart_add + ', ' + _cart_toggle,
            $body = this.dom.$body,
            cart_obj = this._methods._parseAttr($body.attr(_check_cart)),
            is_pd_page = $pd.hasClass(this.settings.product_page_class);

        if(is_pd_page) {
            obj_update = $.extend({
                id: true,
                image: true,
                gallery: true,
                btn_cart: true,
                btn_wsl: true,
                visible: true,
                elem: true,
                url: true
            }, obj_update);
        } else {
            obj_update = $.extend({
                id: true,
                image: true,
                btn_cart: true,
                btn_wsl: true,
                visible: true,
                elem: true
            }, obj_update, {
                gallery: false,
                url: false
            });
        }

        if(obj_update.id) {
            $pd.attr(_id, obj['id']);
            $pd.find('input[name="id"]').prop('value', obj['id']);
        }

        if (_image_toggle) {
            $.each($('.slider-thumbnailed-nav [data-prdbut-image-id]:not(.slick-cloned)'), function() {
                var $this = $(this);
                if ($this.attr('data-prdbut-image-id') == _image_toggle.match(/\d+$/ig)) {
                    if ($this.hasClass('slick-slide')) {
                        $this.trigger("click");
                    } else {
                        $this.parent('.slick-slide').trigger("click");
                    }
                }
            })
        }

        if(obj_update.btn_cart) this.checkBtn($pd, obj['id'], cart_obj, _btns_cart_add);
        if(obj_update.visible) this.checkVisible($pd, obj);
        if(obj_update.url) this.replaceUrl(obj['id'], obj_update.url);
        if(obj_update.elem) this.replaceElem($pd, obj);

        Berserk.currency.update();

    },
    replaceElem: function($pd, obj) {
        var _replace = this.attr.replace_elem,
            _info_replace = this.settings.variants_info_replace,
            _disabled = this.settings.visible_disabled_class,
            $replace = $pd.find('[' + _replace + ']');

        $.each($replace, function() {
            var $elem = $(this),
                $replaceElem,
                prop = $elem.attr(_replace);

            if(obj[_info_replace][prop]) $replaceElem = $(obj[_info_replace][prop]);
            else $replaceElem = $('<a>').addClass(_disabled);

            $elem.replaceWith($replaceElem.attr(_replace, prop));

            $elem.off().remove();
        });
    },
    checkBtn: function($pd, id, obj, btn) {
        if (!obj) return;

        var $btn = $pd.find(btn),
            present = false;

        $.each(obj, function(i, v) {
            if(+v === +id) {
                present = true;
                return false;
            }
        });
    },
    checkVisible: function($pd, obj) {
        var _visible = this.attr.visible_elem,
            _info_visible = this.settings.variants_info_visible,
            _disabled = this.settings.visible_disabled_class,
            $visible = $pd.find('.ajax_add_to_Cart_Btn');

        if (obj[_info_visible]['available'] === false) {
            $visible.addClass(_disabled).prop( "disabled", true ).contents().last().replaceWith("sold out");
            $visible.find('i').removeAttr('class').addClass('fas fa-times');
        } else {
            $visible.removeClass(_disabled).prop( "disabled", false ).contents().last().replaceWith("Add to cart");
            $visible.find('i').removeAttr('class').addClass('fa fa-shopping-basket');
        }

        /*$visible.each(function() {
            var $elem = $(this),
                prop = $elem.attr(_visible),
                value,
                reverse = prop.charAt(0) === '!';

            if(reverse) prop = prop.slice(1);

            value = (obj[_info_visible][prop] && obj[_info_visible][prop] === true) ? true : false;

            if(reverse) value = !value;

            if(value) $elem.removeClass(_disabled);
            else $elem.addClass(_disabled);
        });*/
    },

    _tocartHandlers: function() {
        var _self = this,
            _cart_count = this.selector.cart_count,
            _product = this.selector.cart_product,
            _id = this.attr.variant_id,
            _selected = this.attr.variant_selected,
            _cart_del = this.selector.cart_del;

        function removeFromCart($btn, e) {
            var $product = $btn.parents(_product),
                is_selected = $product.attr(_selected);

            if(is_selected) {
                var id = $product.attr(_id);
                Berserk.myCart.removeItem(id);

                e.preventDefault();
                return false;
            }
        };

        $('body').on('click', _cart_del, function (e) {
            var $btn = $(this);

            removeFromCart($btn, e);
        });

        $('body').on('keyup customchange', _cart_count, function () {
            var $input = $(this),
                $product = $input.parents('.brk-mini-cart__product '),
                quantity = $input.val(),
                id = $product.attr('data-prdbut-id');

            Berserk.myCart.changeItem(id, quantity);
        });
    },

    _methods: {
        _cloneObj: function (obj, ignoreProp) {
            var clone = {};

            for(var key in obj) {
                if(ignoreProp && key === ignoreProp) continue;

                clone[key] = obj[key];
            }

            return clone;
        },
        _sortByKey: function (obj) {
            var new_obj = {},
                keys = Object.keys(obj),
                i = 0;

            keys.sort();

            for (; i < keys.length; i++) {
                var k = keys[i];

                new_obj[k] = obj[k];
            }

            return new_obj;
        },
        _isEqual: function (obj1, obj2) {
            var str1 = JSON.stringify(this._sortByKey(obj1)),
                str2 = JSON.stringify(this._sortByKey(obj2));

            return (str1 === str2) ? true : false;
        },
        _parseAttr: function(attr) {
            if(attr !== undefined) return attr.length ? attr.split(', ') : [];
            else return false;
        },
        _parseJSON: function(str) {
            return (str && str.length) ? JSON.parse(str) : {};
        },
        _setAttrObjJSON: function($pd, attr, obj) {
            obj && Object.keys(obj).length ? $pd.attr(attr, JSON.stringify(obj)) : $pd.removeAttr(attr);
        }
    },
});
Berserk.counter = function() {
    var counter = '.brk-quantity';
    var timer;


    $(document).on('click', counter + ' .brk-quantity__arrows', function (e) {
        var $this = $(this),
            $counter = $this.parents('.brk-quantity'),
            $input = $counter.find('.brk-quantity__value'),
            min_val = 1,
            max_val = Infinity,
            direction,
            val = +$input.val(),
            set_val;

        if ($this.hasClass('minus')) {
            direction = 'minus';
        } else if ($this.hasClass('plus')) {
            direction = 'plus';
        }

        if(!$.isNumeric(val)) {
            $input.val(min_val);
            e.preventDefault();
            return false;
        }

        if(direction === 'plus') {
            set_val = ++val;
        } else if(direction === 'minus') {
            set_val = --val;
        }

        if(set_val < min_val) {
            set_val = min_val;

            e.stopPropagation();
        } else if(set_val > max_val) {
            set_val = max_val;

            e.stopPropagation();
        }

        if(set_val < 0) set_val = 0;

        $input.val(set_val);

        if(timer) clearTimeout(timer);
        timer = setTimeout(process, 1000);

        function process(){
          //Called 5000ms after #myButton was last clicked 
          $input.trigger('customchange');
        }
    });

    $(document).on('click', counter + ' .brk-quantity__arrows', function (e) {
        $input.trigger('customchange');
    });

    $(document).on('keydown', counter, function (e) {
        var keyArr = [8, 9, 27, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];

        if($.inArray(e.keyCode, keyArr) === -1) {
            e.preventDefault();
            return false;
        }
    });

    $(document).on('focus', counter, function (e) {
        $(this).select();
    });

    $(document).on('blur', counter, function (e) {
        var $this = $(this),
            $input = $this,
            val = +$input.val(),
            min_val = 1,
            max_val = Infinity;

        if(!$.isNumeric(val)) {
            $input.val(min_val);
            // console.log('customchange');
			$input.trigger('customchange');
		} else if(val < min_val) {
            $input.val(min_val);
            // console.log('customchange');
			$input.trigger('customchange');
		} else if(val > max_val) {
            $input.val(max_val);
            // console.log('customchange');
			$input.trigger('customchange');
		}
    });
};
/**
 * (c) Tonytemplates Ltd, https://www.tonytemplates.com/support@tonytemplates.com
 */
Berserk.currency = {
    construct: function() {
        this.dom = {
            $currencies: $('#currencies'),
            $current: $('.active-currency')
        };
    },
    init: function() {
        Berserk.currency = new this.construct;
    }
};

Berserk.currency.construct.prototype = $.extend({}, Berserk.currency.construct.prototype, {
    load: function() {
        var _self = this,
            $currencies = this.dom.$currencies,
            $currentCurrency = this.dom.$current,
            $resetActiveCurrency = $currencies.find('li'),
            cookieCurrency;

        try {
            cookieCurrency = Currency.cookie.read();
        } catch(err) {}

        $('span.money span.money').each(function () {
            $(this).parents('span.money').removeClass('money');
        });

        $('span.money').each(function () {
            $(this).attr('data-currency-' + Currency.shopCurrency, $(this).html());
        });

        if (cookieCurrency == null) {
            if (Currency.shopCurrency !== Currency.defaultCurrency) {
                Currency.convertAll(Currency.shopCurrency, Currency.defaultCurrency);
            } else {
                Currency.currentCurrency = Currency.defaultCurrency;
            }
        } else if (cookieCurrency === Currency.shopCurrency) {
            Currency.currentCurrency = Currency.shopCurrency;
        } else {
            Currency.convertAll(Currency.shopCurrency, cookieCurrency);
            $currentCurrency.html(cookieCurrency + '<i class="fa fa-caret-down" aria-hidden="true"></i>');
            $resetActiveCurrency.find('a').each(function () {
                var $this = $(this);

                if ($this.data('currency-code') == cookieCurrency) {
                    $this.parent().addClass('active');
                } else {
                    $this.parent().removeClass('active');
                }
            });
        }
        
        if($('body').data('currency-multiple')) {
            _self.handlers();
        }
    },
    handlers: function() {
        var _self = this;

        $('#currencies li a').on('click', function (e) {
            var $this = $(this),
                $currencies = _self.dom.$currencies,
                $currentCurrency = _self.dom.$current,
                $resetActiveCurrency = $currencies.find('li'),
                newCurrency;

            newCurrency = $this.data('currency-code');
            $resetActiveCurrency.removeClass('active');

            if (newCurrency == Currency.currentCurrency) {
                Currency.convertAll(Currency.shopCurrency, newCurrency);
            } else {
                Currency.convertAll(Currency.currentCurrency, newCurrency);
            }

            $this.parent().addClass('active');
            $currentCurrency.html(newCurrency + '<i class="fa fa-caret-down" aria-hidden="true"></i>');
            $('.tt-header__settings > i').trigger('togglelist.close');

            e.preventDefault();
            return false;
        });
    },
    update: function() {
        var $currencies = this.dom.$currencies;

        $currencies.find('li.active > a').trigger('click');
    }
});
Berserk.productSlider = {
    section: {
        destroy: function() {

        }
    }
};
Berserk.SwiperSlider = {
    section: {
        destroy: function() {

        }
    }
};
Berserk.TeamList = {
    section: {
        destroy: function() {
        	// console.log('destroyed');
        }
    }
};
Berserk.HeaderSection = {
    section: {
        destroy: function(context) {
			console.log('destr header');
        	// $(context).parent().find('.brk-tilter').removeClass('rendered');
        }
    }
};
Berserk.CollectionPreviewCard = {
    section: {
        destroy: function(context) {
        }
    }
};
Berserk.section.collection = {
    construct: function() {
        this.collection = null;
        this.collectionPresent = false;
        this.params = {};
        this.unallocatedСonstraint = [];
        this.paramsUrlSeparate = {
            'default': '+',
            'view': '-'
        };
        
        this.dom = {
            $listing_page: $('.brk-listing-page'),
            $length: $('.brk-vw-opt__length'),
            $filters: $('.brk-collection-param'),
            $categories: $('.brk-categories-filter'),
            $sort: $('.brk-vw-opt__sort'),
            $view: $('.brk-product-btn-vw'),
            $products: $('.brk-product-view'),
        };

        this.parseUrl();
        this.saveParams();
        this.getParams();
        this.handlers();
        this.eventFilter();
        this.eventHistory();
    },
    init: function() {
        this.build = new this.construct;
    },
    destroy: function() {
        this.dom.$categories.off();
        this.build = null;
    }
}

Berserk.section.collection.construct.prototype = $.extend({}, Berserk.section.collection.construct.prototype, {
    parseUrl: function() {
        var _self = this,
            url = decodeURIComponent(location.href) || location.href,
            cur_text = 'collections',
            pos = url.indexOf(cur_text),
            str = url.slice(pos + cur_text.length);

        str = str.split('?');

        var url_body = str[0],
            url_get = str[1];

        url_body = url_body.split('/');

        var collection = url_body[1],
            filter_body = url_body[2],
            params = {};

        if(filter_body) {
            filter_body = filter_body.split('+');
        }

        if(url_get) {
            var filter_get = {};

            url_get = url_get.split('&');

            $(url_get).each(function(key, value) {
                value = value.split('=');

                var k = value[0],
                    separate = (_self.paramsUrlSeparate.hasOwnProperty(k)) ? _self.paramsUrlSeparate[k] : _self.paramsUrlSeparate['default'];

                filter_get[k] = value[1].split(separate);
            });

            params = $.extend({}, filter_get);
        }

        if(Array.isArray(filter_body)) {
            if(!params['constraint']) params['constraint'] = [];

            params['constraint'] = $.merge(params['constraint'], filter_body);
        }

        this.collection = collection;
        this.params = params;
        this.unallocatedСonstraint = (Array.isArray(this.params['constraint'])) ? this.params['constraint'].slice() : [];

        this.current_url = url;
        this.collectionPresent = false;
    },
    viewHandler: function() {
        var _self = this,
            $view = this.dom.$view,
            $control = $($view.attr('data-control')),
            $a = $view.find('a'),
            $initCount = $('.brk-sc-sorting__show-count select option:selected').attr('data-brk-value'),
            $viewCount = $('[data-brk-property="view"]').attr('data-brk-params'),
            url = decodeURIComponent(location.href) || location.href,
            cur_text = 'view',
            pos = url.indexOf(cur_text),
            params = '',
            str,
            setCount;

        if (pos > 0) {
            str = url.slice(pos);
            str = str.split('&')[0];
        }

        // if ($viewCount == undefined || $viewCount < 0) {
        if ($viewCount+0 < 1) {
            setCount = $initCount;
        } else {
            setCount = $viewCount;
        }

        $a.each(function() {
            var viewType = $(this).attr('data-brk-value');

            if ($(this).hasClass('active-view')) {
                $('.brk-sc-sorting__show-count  select option').each(function() {
                    var vallNow = $(this).attr('data-brk-value');
                    $(this).attr('data-brk-value', vallNow+'-'+viewType);
                })
            }

            $(this).attr('href', url.split('?')[0] + '?view='+parseInt(setCount, 10)+'-'+viewType);
        })

        $a.on('click', function(e) {
            var aHref = $(this).attr('href');
            if (aHref = url) {
                // e.preventDefault();
            }
        })
    },
    sortHandler: function() {
        var  _self = this,
            $sort = this.dom.$sort;
            $drop = $('.jq-selectbox').find('.jq-selectbox__dropdown li');

        $(document).on('click', '.brk-sc-sorting__sort-select .jq-selectbox__dropdown li', function(e) {
            //start filter
            $sort.attr('data-brk-params', $sort.find('li.selected').attr('data-brkvalue'));

            // _self.dom.$loadmore.removeAttr('data-brk-params');

            _self.refreshParams();
            //end filter
        });

        $(document).on('change', '.brk-sc-sorting__sort-select ', function(e) {
            //start filter
            $sort.attr('data-brk-params', $sort.find('li.selected').attr('data-brkvalue'));

            // _self.dom.$loadmore.removeAttr('data-brk-params');

            _self.refreshParams();
            //end filter
        });
    },
    lengthHandler: function() {
        var  _self = this,
            $length = this.dom.$length;

        // $length.find('select').on('change', function() {
        $(document).on('click', '.brk-sc-sorting__show-count .jq-selectbox__dropdown li', function(e) {
            //start filter
            $length.attr('data-brk-params', $length.find('li.selected').attr('data-brkvalue'));

            // _self.dom.$pagination.removeAttr('data-brk-params');
            // _self.dom.$loadmore.removeAttr('data-brk-params');

            _self.refreshParams();
            _self.viewHandler();
            //end filter
        });

        $(document).on('change', '.brk-sc-sorting__show-count', function(e) {
            //start filter
            $length.attr('data-brk-params', $length.find('li.selected').attr('data-brkvalue'));

            // _self.dom.$pagination.removeAttr('data-brk-params');
            // _self.dom.$loadmore.removeAttr('data-brk-params');

            _self.refreshParams();
            _self.viewHandler();
            //end filter
        });
    },
    refreshParams: function(params) {
        this.dom.$products.addClass('ttg-loading');

        params = params || {};

        this.getParams();

        if(!params.skip_history) {
            this.setUrl();
        } else {
            this.buildUrl();
        }

        this.ajaxRequest(params);
        // this.addCurrentTags();
    },
    getParams: function() {
        var _self = this;

        this.params = {};

        this.dom.$filters.each(function() {
            var $this = $(this),
                property = $this.attr('data-brk-property') || 'constraint',
                params = $this.attr('data-brk-params');

            if(property === 'collection' && params) {
                _self.collection = params;
            } else if(params) {
                var params_obj = params.split(',');

                if(!Array.isArray(_self.params[property])) _self.params[property] = [];

                $.each(params_obj, function(key, value) {
                    var is_present = false;

                    value = value.trim();

                    $.each(_self.params[property], function(k, v) {
                        if(value === v.trim()) is_present = true;
                    });

                    if(!is_present) _self.params[property].push(value);
                });
            }
        });
    },
    buildUrl: function() {
        var _self = this,
            params = this.params,
            get = '',
            is_first_key = true;

        var forUrl = $('.active-view').attr('href'),
            cur_text = 'view=',
            pos = forUrl.indexOf(cur_text),
            str = forUrl.slice(pos + cur_text.length);

        str = str.split('?');

        var url_body = str[0],
            url_get = str[1];

        $.each(params, function(key, value) {
            if(!value.length) {
                delete params[key];
                return;
            };

            var separate = (_self.paramsUrlSeparate.hasOwnProperty(key)) ? _self.paramsUrlSeparate[key] : _self.paramsUrlSeparate['default'],
                is_first_value = true;

            if(is_first_key) is_first_key = false;
            else get += '&';

            get += key + '=';

            $.each(value, function(k, v) {
                if(is_first_value) is_first_value = false;
                else get += separate;

                v = v.trim();

                if (!isNaN(v)) {
                    v = str;
                }
                get += v;
            });
        });

        if(get.length) get = '?' + get;

        this.current_url = '/collections/' + this.collection + get;

        this.current_url = this.current_url.replace(/#/g,'').replace(/\s/ig, '-').replace(/\-+/g,'-');
    },
    setUrl: function(params) {
        this.buildUrl();

        history.pushState({foo: 'bar'}, this.current_url, this.current_url);
    },
    ajaxRequest: function(params) {
        var _self = this;

        $.ajax({
            type: 'GET',
            url: this.current_url,
            cache: false,
            success: function (content) {
                _self.replaceContent(content, params);
            },
            error: function (jqXHR, exception) {
                console.log('Ajax error');
                console.log('Error status: ' + jqXHR.status);
            }
        });
    },
    replaceContent: function(content, params) {
        var _self = this,
            $content = $(content);

        params = params || {};

        function replaceProducts(params) {
            var $products = _self.dom.$products,
                $new_products = $content.find('.brk-product-view');

            if(_self.pagination_type === 'load_more' && params.save_products) {
                $products.append($($new_products.html()));
            } else if (_self.pagination_type === 'scroll' && params.save_products) {
                $products.append($($new_products.html()));
            } else {
                $products.html($new_products.html());
            }

            // Mogo.productScroll(true);
        };

        function replaceElems() {
            var $listing = _self.dom.$listing_page,
                $elems = $listing.find('[data-collection-replace]');

            if(params.paginate) $elems = $elems.filter('[data-collection-replace="paginate"]');

            $elems.each(function() {
                var $elem = $(this),
                    className = $elem.attr('class');

                $elem.html($content.find('[class="' + className + '"]').html());
            });
        };

        this.dom.$products.addClass('ttg-loading');

        replaceProducts(params);

        replaceElems();

        // if($sticky.hasClass('initialize')) {
        //     $sticky.stickySidebar('updateSticky');
        // }

        this.dom.$products.removeClass('ttg-loading').removeAttr('style');

        /*if(this.dom.$loadmore.length) {
            this.dom.$loadmore.removeClass('btn__state--wait');
        }*/

        if(params.complete) {
            params.complete();
        }
    },
    addCurrentTags: function() {
        var $current_tags = this.dom.$current_tags,
            show_rprice = $current_tags.attr('data-show-rprice'),
            constraint = (Array.isArray(this.params['constraint'])) ? this.params['constraint'] : [];

        if($current_tags.length) {
            $current_tags.html('');

            if(constraint.length) {
                $current_tags.parent().removeClass('ttg-hidden');

                $.each(constraint, function(key, value) {
                    if(show_rprice === 'false' && value.indexOf('rprice-') !== -1) {
                        return;
                    }

                    var $tag = $('<span>').attr('data-tt-value', value).html(value + '<i class="icon-cancel-1"></i>');

                    $current_tags.append($tag);
                });

                if(!$current_tags.find('[data-tt-value]').length) {
                    $current_tags.parent().addClass('ttg-hidden');
                }
            } else {
                $current_tags.parent().addClass('ttg-hidden');
            }
        }
    },
    eventFilter: function() {
        var _self = this,
            $filters = this.dom.$filters;

        $filters.on('filterchange', function() {
            _self.refreshParams();
        });
    },
    eventHistory: function() {
        var _self = this;

        $(window).on('popstate', function() {
            _self.dom.$products.addClass('ttg-loading');

            _self.parseUrl();
            _self.ajaxRequest();
            _self.saveParams(true);
            _self.addCurrentTags();
        });
    },
    saveParams: function(establish) {
        this.saveCategoryParams(establish);
        this.saveSortParams(establish);
        this.saveLengthParams(establish);
        // this.saveViewParams(establish);
        this.savePriceParams(establish);
        this.addUnallocated();
        this.checkCollection();
    },
    saveCategoryParams: function(establish)  {
        var _self = this;

        this.dom.$categories.each(function() {
            var $this = $(this),
                $li = $this.find('li'),
                $a = $this.find('a[data-brk-value]'),
                arr = [];

            if(establish === true) {
                $a.removeClass('active');
            }

            $a.each(function() {
                var $this = $(this),
                    value = $this.attr('data-brk-value').trim().replace(' ', '-');

                if(value === _self.collection) {
                    if(establish === true) {
                        $this.addClass('active');
                    }

                    arr.push(value);

                    _self.collectionPresent = true;
                } else {
                    $.each(_self.params['constraint'], function(k, v) {
                        v = v.trim();

                        if(value === v) {
                            if(establish === true) {
                                $this.addClass('active');
                            }

                            _self.deleteFromUnallocated(value);

                            arr.push(value);
                        }
                    });
                }
            });

            $this.attr('data-brk-params', arr.join(', '));
        });
    },
    saveSortParams: function(establish) {
        var _self = this,
            $sort = this.dom.$sort,
            $options = $sort.find('option'),
            arr = [];

        if(establish === true) {
            $options.removeAttr('selected');
        }

        $options.each(function() {
            var $this = $(this),
                value = $this.attr('data-brk-value').trim().replace(' ', '-');

            $.each(_self.params['sort_by'], function(k, v) {
                v = v.trim();

                if(value === v) {
                    if(establish === true) {
                        $this.prop('selected', true);
                    }

                    arr.push(value);
                }
            });
        });

        $sort.attr('data-brk-params', arr.join(', '));
    },
    saveLengthParams: function(establish) {
        var _self = this,
            $length = this.dom.$length,
            $options = $length.find('option'),
            arr = [];

        if(establish === true) {
            $options.removeAttr('selected');
        }

        $options.each(function() {
            var $this = $(this),
                value = $this.attr('data-brk-value').trim().replace(' ', '-');

            $.each(_self.params['view'], function(k, v) {
                v = v.trim();

                if(value === v) {
                    if(establish === true) {
                        $this.prop('selected', true);
                    }

                    arr.push(value);
                }
            });
        });

        $length.attr('data-brk-params', arr.join(', '));
    },
    saveViewParams: function(establish) {
        var _self = this,
            $view = this.dom.$view,
            $inputs = $view.find('.brk-sc-view-swiper__btn'),
            arr = [],
            params = '';

        if(establish === true) {
            var $control = $($view.attr('data-control'));

            $inputs.each(function () {
                var view = $(this).attr('data-brk-value');

                $control.removeClass(view);
            });

            $inputs.removeAttr('checked');
        }

        $inputs.each(function() {
            var $this = $(this),
                value = $(this).attr('data-brk-value').trim().replace(' ', '-');

            $.each(_self.params['view'], function(k, v) {
                v = v.trim();

                if(value === v) {
                    if(establish === true) {
                        $this.prop('checked', true);
                        $control.addClass($this.attr('data-view-class'));
                    }

                    arr.push(value);
                }
            });
        });

        params = arr.join(', ');

        if(establish === true && !params.length) {
            var default_params = $view.attr('data-brk-default'),
                $default_input = $inputs.filter('[data-brk-value="' + default_params + '"]');

            $default_input.prop('checked', true);

            $control.addClass($default_input.attr('data-view-class'));
        }

        $view.attr('data-brk-params', params);
    },
    deleteFromUnallocated: function(param) {
        var _self = this;

        $.each(this.unallocatedСonstraint, function(key, value) {
            if(value === param) {
                _self.unallocatedСonstraint.splice(key, 1);
            }
        });
    },
    addUnallocated: function() {
        var _self = this,
            $unallocated = this.dom.$unallocated;

        $.each(this.unallocatedСonstraint, function(k, v) {
            var index = v.indexOf('rprice-');

            if(index !== -1) {
                _self.unallocatedСonstraint.splice(index, 1);
            }
        });

        if($unallocated.hasClass('active') && this.unallocatedСonstraint.length) {
            $.each(this.unallocatedСonstraint, function(key, value) {
                var $add_filter = $('<a>').attr('href', '#' + value).attr('data-tt-value', value).html(value);

                $add_filter = $('<li>').addClass('active').append($add_filter);

                $unallocated.append($add_filter);
            });

            $unallocated.attr('data-tt-params', this.unallocatedСonstraint.join(', '));
            $unallocated.parent().removeClass('ttg-hidden');
        } else {
            $unallocated.html('');
            $unallocated.removeAttr('data-tt-params');
            $unallocated.parent().addClass('ttg-hidden');
        }
    },
    checkCollection: function() {
        var $collections = this.dom.$categories.filter('[data-brk-property="collection"]');

        if($collections.length && !this.collectionPresent && this.collection) {
            var collection = this.collection,
                collection_title = collection.replace(/-/gim, ' ').split(' ');

            for(var i = 0; i < collection_title.length; i++) {
                collection_title[i] = collection_title[i].charAt(0).toUpperCase() + collection_title[i].substr(1).toLowerCase();
            }

            collection_title = collection_title.join(' ');

            var $add_collection = $('<a>').attr('href', '#' + collection).attr('data-brk-value', collection).html(collection_title);

            $add_collection = $('a').addClass('active').append($add_collection);

            $collections.append($add_collection);
        }
    },
    categoryHandler: function() {
        var _self = this,
            $categories = this.dom.$categories,
            breakpoint = 1024,
            anim_duration = 500,
            interval;

        $categories.on('click', 'a', function (e) {

            var $this = $(this),
                $category = $this.parents('.brk-categories-filter'),
                property = $category.attr('data-brk-property'),
                $li = $this.parent(),
                params = [];

            if((property === 'collection' && !$this.hasClass('active')) || ($category.attr('data-radio') && !$this.hasClass('active'))) {
                _self.dom.$products.addClass('ttg-loading');

                $category.find('a').removeClass('active');

                $this.filter('.active').not('.tt-categories__open').find('> i').trigger('click');
            } else if ($category.attr('data-radio') && $this.hasClass('active')) {
                _self.dom.$products.addClass('ttg-loading');
            } else if (property === 'collection' && $this.hasClass('active')) {
                e.preventDefault();
                return false;
            }

            if(property === 'collection' && !$this.hasClass('active')) {
                $categories
                    .not($category)
                    .removeAttr('data-brk-params')
                    .find('a')
                    .removeClass('active');

                _self.savePriceParams(false, true);
            }

            $this.toggleClass('active');

            //start filter
            $category.find('a').each(function() {
                var $this = $(this);

                if($this.hasClass('active')) params.push($this.attr('data-brk-value'));
            });

            $category.attr('data-brk-params', params.join(', '));

            // _self.dom.$pagination.removeAttr('data-tt-params');
            // _self.dom.$loadmore.removeAttr('data-tt-params');

            _self.refreshParams();
            //end filter

            e.preventDefault();
            return false;
        });

        $categories.on('click.', '.tt-categories__next', function () {
            var $this = $(this),
                $li = $this.parent(),
                $ul = $li.find('> ul').first(),
                wind_w = window.innerWidth,
                desktop = wind_w > breakpoint;

            $li.toggleClass('tt-categories__open');

            if($ul.length) {
                if($li.hasClass('tt-categories__open')) {
                    if(desktop) {
                        clearInterval(interval);
                        interval = setInterval(function () {
                            $(window).trigger('stickySide.position');
                        }, 5);
                    }

                    $ul.velocity('stop').removeAttr('style').velocity( 'slideDown', {
                        duration: anim_duration,
                        complete: function () {
                            clearInterval(interval);
                        }
                    });
                } else {
                    $ul.velocity('stop').velocity( 'slideUp', {
                        duration: anim_duration,
                        complete: function () {
                            $(window).trigger('stickySide.position');
                        }
                    });
                    $ul.find('ul').velocity('stop').velocity( 'slideUp', anim_duration );
                    $ul.find('li').removeClass('tt-categories__open');
                }
            }
        });

        function openActive() {
            var $categories_active = $categories.find('a.active');

            $categories_active.addClass('active');

            $categories_active
                .add($categories_active.parents('.brk-categories-filter'))
                .addClass('brk-categories__open')
                .find('> a').show();
        };

        openActive();

        $categories.on('openactive', function() {
            openActive();
        });
    },
    isActiveFilter: function() {
        var _self = this,
            url = decodeURIComponent(location.href) || location.href,
            cur_text = 'collections',
            pos = url.indexOf(cur_text),
            str = url.slice(pos + cur_text.length),
            arrFilter = [];

        str = str.split('?');

        var url_body = str[0],
            url_get = str[1];

        // console.log(url_body);
        // console.log(url_get);

        $('.brk-categories-filter').each(function() {
            $(this).find('[data-brk-value]').each(function() {
                // arrFilter.push($(this).attr('data-brk-value').replace(/\s\s+/g, ''));
                arrFilter.push($(this).attr('data-brk-value').replace(/\s/g,''));
            })
        })

        console.log(arrFilter);

        for (var i = arrFilter.length - 1; i >= 0; i--) {
            if (url.indexOf(arrFilter[i])>0) {
                console.log(arrFilter[i]);
                // $('.brk-categories-filter').find('[data-brk-value="' + arrFilter[i] + '"]').addClass('active');
                // $('.brk-categories-filter [data-brk-value]').indexOf(searchElement: any, fromIndex?: int).addClass('active');
                $('.brk-categories-filter [data-brk-value]').eq( i ).addClass('active');
            }
            // arrFilter[i]
            // url
        }
        
    },

    saveParams: function(establish) {
        this.saveCategoryParams(establish);
        this.saveSortParams(establish);
        this.saveLengthParams(establish);
        this.saveViewParams(establish);
        // this.addUnallocated();
        // this.checkCollection();
    },
    handlers: function() {
        this.categoryHandler();
        this.viewHandler();
        this.sortHandler();
        this.lengthHandler();
        this.isActiveFilter();
    }
});

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    this.onLoad();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    onLoad: function() {
      Berserk.behaviors.swiper_slider_init.attach($('body'), Berserk.settings);
      Berserk.behaviors.slick_init.attach($('body'), Berserk.settings);
      Berserk.behaviors.tabs_init.attach($('body'), Berserk.settings);
      Berserk.behaviors.element_init.attach($('body'), Berserk.settings);
      Berserk.behaviors.tabs_slider_init.attach($('body'), Berserk.settings);
      
      // Berserk.behaviors.widgets_carousel_init.attach($('body'), Berserk.settings);
      // Berserk.behaviors.widgets_slider_cube_init.attach($('body'), Berserk.settings);
      // Berserk.behaviors.progressbar_init.attach($('body'), Berserk.settings);
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */



    onUnload: function() {
      // console.log('loadProduct');
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Sidebar = (function () {
    function Section(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {};
        this.namespace = '.footer';

        this.onLoad();
    }

    Section.prototype = $.extend({}, Section.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        onLoad: function() {
            console.log('Blog sidebar load');
            
            Berserk.behaviors.widgets_carousel_init.attach($('body'), Berserk.settings);
            // Berserk.section.collection.init();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
            console.log('Blog sidebar unload!');
            // Berserk.section.collection.destroy();
        }
    });

    return Section;
})();
theme.HeaderSection = (function () {

	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.header';

		this.onLoad();
	}

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			// console.log('onLoad');
			Berserk.behaviors.header_init.attach($('body'), Berserk.settings);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);
			Berserk.HeaderSection.section.destroy(this.$container);
			// console.log('onUnload');
		}
	});

	return Section;
})();
theme.Revolution = (function () {

	function Revolution(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.rev_slider';

		this.onLoad();
	}

	// console.log(Section.prototype);

	Revolution.prototype = $.extend({}, Revolution.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Berserk.revolutionSlider.section.init();
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			Berserk.revolutionSlider.section.destroy();
		}
	});
	// Berserk.revolutionSlider.section.destroy();
	// console.log(Section.prototype);
	// Berserk.revolutionSlider.section.init();

	return Revolution;
})();
theme.ProductSlider = (function () {

	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.product_slider';

		this.onLoad();
	}

	// console.log(Section.prototype);

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Berserk.behaviors.slick_init.attach($('body'), Berserk.settings);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			Berserk.productSlider.section.destroy(this.$container);
		}
	});
	// Berserk.revolutionSlider.section.destroy();
	// console.log(Section.prototype);
	// Berserk.revolutionSlider.section.init();

	return Section;
})();
theme.SwiperSlider = (function () {

	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.swiper_slider';

		this.onLoad();
	}

	// console.log(Section.prototype);

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Berserk.behaviors.swiper_slider_init.attach($('body'), Berserk.settings);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);

			
			
			Berserk.SwiperSlider.section.destroy(this.$container);
		}
	});
	// Berserk.revolutionSlider.section.destroy();
	// console.log(Section.prototype);
	// Berserk.revolutionSlider.section.init();

	return Section;
})();
theme.TeamList = (function () {

	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.team';

		this.onLoad();
	}

	// console.log(Section.prototype);

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			// console.log('onload');
			Berserk.behaviors.material_card_init.attach($('.mc-btn-action'), Berserk.settings);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			// console.log('onUnload');
			this.$container.off(this.namespace);
			Berserk.TeamList.section.destroy(this.$container);
		}
	});
	// Berserk.revolutionSlider.section.destroy();
	// console.log(Section.prototype);
	// Berserk.revolutionSlider.section.init();

	return Section;
})();
theme.CollectionPreviewCard = (function () {

	function Section(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		this.settings = {};
		this.namespace = '.tilter';

		this.onLoad();
	}

	Section.prototype = $.extend({}, Section.prototype, {

		/**
		 * Handles change events from the variant inputs
		 */
		onLoad: function() {
			Berserk.behaviors.image_caption_init.attach($('body'), Berserk.settings);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function () {
			this.$container.off(this.namespace);
			console.log('to destr tiller');
			Berserk.CollectionPreviewCard.section.destroy($('.brk-tilter__caption'), this.$container);
		}
	});

	return Section;
})();
theme.CollectionSection = (function () {
    function Section(container) {
        this.$container = $(container);
        var sectionId = this.$container.attr('data-section-id');

        this.settings = {};
        this.namespace = '.footer';

        this.onLoad();
    }

    Section.prototype = $.extend({}, Section.prototype, {

        /**
         * Handles change events from the variant inputs
         */
        onLoad: function() {
            Berserk.section.collection.init();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
            Berserk.section.collection.destroy();
        }
    });

    return Section;
})();


$(document).ready(function() {
  var sections = new slate.Sections();
      sections.register('header', theme.HeaderSection);
      sections.register('collection-preview-card', theme.CollectionPreviewCard);
      sections.register('revolution-slider', theme.Revolution);
      sections.register('revolution-slider-3', theme.Revolution);
      sections.register('product-slider', theme.ProductSlider);
      sections.register('triple-slider', theme.ProductSlider);
      sections.register('testimonials', theme.SwiperSlider);
      sections.register('our_skills', theme.SkillSection);
      sections.register('team-list', theme.TeamList);
      sections.register('product', theme.Product);
      sections.register('blog-sidebar', theme.Sidebar);
      sections.register('footer', theme.FooterSection);
      sections.register('collection-wrap', theme.CollectionSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Not sure. TODO rework to invoke only needed JS
  for(var key in window.Berserk) {
    if(typeof window.Berserk[key] === 'function') {
      window.Berserk[key]();
    } else if (window.Berserk[key].init && typeof window.Berserk[key].init === 'function') {
      window.Berserk[key].init();
    }
  }

  $(window).trigger('Berserk.load');
});
